"use strict";

import { gsap } from "gsap/dist/gsap.min";
// Importa Swiper core y los estilos

/* global Swiper */

import { ScrollTrigger } from "gsap/dist/ScrollTrigger.min";
// ScrollSmoother requires ScrollTrigger

import filtrado from "./filtrado";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function () {
    const filtrado_ = new filtrado();
    filtrado_.init();

    //Menu mobile
    const menuMobile = document.querySelector(".menu-wrapper");
    const slider = document.getElementById("menuSlider");
    const level2Title = document.getElementById("level2-title");
    const level2List = document.getElementById("level2-list");
    const hamburguesa = document.getElementById("hamburguesa");
    const closeMenu = document.getElementById("closeMenu");
    const $guardarPassword = document.getElementById("guardarPassword");
    const $atrasPopup = document.querySelectorAll(".atras-popup");

    // POP UP
    const $buttonFilter = document.querySelectorAll('[data-popup="filter"]');
    const $buttonStatus = document.querySelectorAll('[data-popup="status"]');
    const $buttonCapacity = document.querySelectorAll('[data-popup="capacity"]');
    const $buttonMemory = document.querySelectorAll('[data-popup="memory"]');
    const $buttonDescription = document.querySelectorAll('[data-popup="description"]');
    const $editarPassword = document.querySelectorAll('[data-popup="edit-password"]');
    const $cancelarPedido = document.querySelectorAll('[data-popup="cancelar-pedido"]');
    const $generico = document.querySelectorAll('[data-popup="generico"]');
    const $eliminarDireccion = document.querySelectorAll('[data-popup="eliminar-direccion"]');
    const $buttonSerie = document.querySelectorAll('[data-popup="nserie"]');

    const $contentFilter = document.getElementById("content-filter-popup");
    const $contentStatus = document.getElementById("content-status-popup");
    const $contentCapacity = document.getElementById("content-capacity-popup");
    const $contentMemory = document.getElementById("content-memory-popup");
    const $contentSerie = document.getElementById("content-serie");
    const $contentDescription = document.getElementById("content-description-popup");
    const $contentPassword = document.getElementById("content-password-popup");
    const $contentCancelarPedido = document.getElementById("content-cancelar-popup");
    const $contentGenerico = document.getElementById("content-generico-popup");
    const $contentElinimarPedido = document.getElementById("content-eliminar-direccion-popup");

    const $closePopup = document.getElementById("close-popup");

    const $popup = document.getElementById("popup");
    const $popupContent = document.getElementById("popup-content");

    const $imagesProduct = document.querySelector(".swiperProduct");
    const $colorProduct = document.querySelector(".color-product");
    const $inputGroup = document.querySelectorAll(".input-group");
    const $inputPassword = document.querySelectorAll(".password-group");
    const sticky = document.getElementById("stickyTarget");

    const $btnSearch = document.getElementById("btn-search");
    const $btnCloseSearch = document.querySelector(".close-search");
    const $contentSearch = document.getElementById("content-search");

    let isDesktop = window.innerWidth >= 768;

    //open menu mobile
    hamburguesa.addEventListener("click", () => {
        openMenuMobile();
    });

    closeMenu.addEventListener("click", () => {
        closeMenuMobile();
    });
    const openMenuMobile = () => {
        gsap.to(menuMobile, { height: "100dvh", duration: 1, ease: "expo.out" });
    };

    const closeMenuMobile = () => {
        gsap.to(menuMobile, {
            height: 0,
            duration: 0.8,
            ease: "expo.out",
            onComplete: () => {
                slider.style.transform = "translateX(0)";
            },
        });
    };

    // Activar categorías
    document.querySelectorAll(".cat-link").forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const category = link.dataset.cat;
            const models = link.dataset.models.split(",");
            level2Title.textContent = capitalize(category);
            level2List.innerHTML = "";
            models.forEach((model) => {
                const li = document.createElement("li");
                const a = document.createElement("a");
                a.href = "/" + slugify(model);
                a.textContent = model;
                li.appendChild(a);
                level2List.appendChild(li);
            });
            slider.style.transform = "translateX(-50%)";
        });
    });

    // Volver a nivel 1
    document.getElementById("backToLevel1").addEventListener("click", () => {
        slider.style.transform = "translateX(0)";
    });

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function slugify(text) {
        return text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "")
            .replace(/[^\w-]+/g, "");
    }

    // Marquee
    const $marquee = document.querySelector(".marquee");
    if ($marquee) {
        new Swiper(".marquee-swiper", {
            slidesPerView: "auto",
            grabCursor: true,
            freeMode: true,
        });
    }

    // Featured
    const $featuredProducts = document.querySelector(".featured-products");
    if ($featuredProducts) {
        // eslint-disable-next-line no-undef

        new Swiper(".featured-swiper", {
            slidesPerView: 1.2,
            spaceBetween: 24,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
            },
        });
    }

    // Interest
    const $interestProducts = document.querySelector(".interest-products");
    if ($interestProducts) {
        // eslint-disable-next-line no-undef

        new Swiper(".interest-swiper", {
            slidesPerView: 1.5,
            spaceBetween: 16,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
            pagination: {
                el: ".swiper-opinion-pagination",
                clickable: true,
            },
        });
    }

    // Testimonials Section
    const $testimonialsSection = document.querySelector(".testimonials-section");
    if ($testimonialsSection) {
        // eslint-disable-next-line no-undef

        new Swiper(".testimonials-swiper", {
            slidesPerView: 1.5,
            spaceBetween: 24,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                },
            },
        });
    }

    // Hero
    const $sliderHero = document.querySelector(".slider-hero");
    if ($sliderHero) {
        // eslint-disable-next-line no-undef

        new Swiper(".hero-swiper", {
            slidesPerView: 1,
            effect: "fade",
            grabCursor: true,
            navigation: {
                nextEl: ".custom-next",
                prevEl: ".custom-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}"></span>`;
                },
            },
        });
    }

    // Headline{
    const $sidebarsHeadline = document.querySelector(".headline");
    if ($sidebarsHeadline) {
        const speed = 50;

        const carrouselToLeft = gsap.timeline({
            paused: true,
            repeat: -1,
            defaults: { duration: speed, ease: "none" },
        });

        for (let i = 0; i < $sidebarsHeadline.children.length; i++)
            carrouselToLeft.to(
                $sidebarsHeadline.children[i],
                { x: -$sidebarsHeadline.children[0].offsetWidth, paused: false },
                0
            );

        ScrollTrigger.create({
            trigger: $sidebarsHeadline,
            start: "top bottom", // cuando entra en el viewport
            end: "bottom top", // cuando sale del viewport
            onEnter: () => carrouselToLeft.play(),
            onLeave: () => carrouselToLeft.pause(),
            onEnterBack: () => carrouselToLeft.play(),
            onLeaveBack: () => carrouselToLeft.pause(),
        });
    }

    // GUIAS DE MAQUETACIÓN
    let $guides = document.getElementById("guides");
    if ($guides) {
        const $guidesSwitcher = $guides.querySelector(".guides__switcher");
        $guidesSwitcher.addEventListener("click", () => guidesSwitcher());
    }

    const guidesSwitcher = () => {
        // if (!$guides)
        //   return;

        const $guidesHr = $guides.querySelector(".guides__horizontal");

        // $guidesSwitcher.addEventListener('click', function () {
        if ($guidesHr.style.display === "block") {
            gsap.set($guidesHr, { display: "none" });
        } else {
            gsap.set($guidesHr, { display: "block" });
        }
        //   });
    };

    const createFaqs = () => {
        const groups = gsap.utils.toArray(".accordion-group");
        const menus = gsap.utils.toArray(".accordion-menu");
        const menuToggles = groups.map(createAnimation);

        menus.forEach((menu) => {
            menu.addEventListener("click", () => toggleMenu(menu));
        });

        function toggleMenu(clickedMenu) {
            menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
        }

        function createAnimation(element) {
            let menu = element.querySelector(".accordion-menu");
            let box = element.querySelector(".accordion-content");
            let titleAccordion = element.querySelector(".accordion-menu .wysiwyg");
            let plusElement = element.querySelector(".accordion-ico");

            gsap.set(box, {
                height: 0,
            });

            gsap.set(plusElement, {
                transformOrigin: "center center",
            });

            let animation = gsap
                .timeline()
                .to(
                    box,
                    {
                        height: "auto",
                        duration: 0.5,
                        ease: "power1.inOut",
                    },
                    0
                )
                .to(
                    titleAccordion,
                    {
                        duration: 0.2,
                        ease: "none",
                        className: "wysiwyg active",
                    },
                    0
                )
                .to(
                    plusElement,
                    {
                        duration: 0.2,
                        rotation: 180,
                        ease: "none",
                        transformOrigin: "center center",
                    },
                    0
                )
                .reverse();

            return function (clickedMenu) {
                if (clickedMenu === menu) {
                    animation.reversed(!animation.reversed());
                } else {
                    animation.reverse();
                }
            };
        }
    };

    // FAQ
    const $accordion = document.querySelector(".accordion");
    if ($accordion) {
        createFaqs();
    }

    // Swiper Product
    const createSwiperProduct = () => {
        var swiperProductTumb = new Swiper(".swiperProductTumb", {
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
        });

        // eslint-disable-next-line no-unused-vars
        var swiperProduct = new Swiper(".swiperProduct", {
            spaceBetween: 10,
            effect: "fade",
            thumbs: {
                swiper: swiperProductTumb,
            },
        });
    };

    if ($imagesProduct) {
        createSwiperProduct();
    }

    const createColorProduct = () => {
        // Seleccionar todos los radios con name="plan"
        const radios = $colorProduct.querySelectorAll('input[name="colorProduct"]');
        const textColor = $colorProduct.querySelector(".text-color");

        textColor.textContent = radios[0].value;

        radios.forEach((radio) => {
            radio.addEventListener("change", () => {
                if (radio.checked) {
                    textColor.textContent = radio.value;
                }
            });
        });
    };

    if ($colorProduct) {
        createColorProduct();
    }

    // Timeline para abrir
    const tlPopup = gsap.timeline({
        paused: true,
        onReverseComplete: () => {
            gsap.set($popupContent, { clearProps: "all" });
        },
    });

    tlPopup
        .set($popup, {
            display: "flex",
        })
        .to($popup, {
            duration: 0.3,
            opacity: 1,
            ease: "power2.out",
        })
        .to(
            $popupContent,
            {
                duration: 0.3,
                scale: 1,
                opacity: 1,
                ease: "power2.out",
            },
            "-=0.3"
        );

    // Popup Filtrado
    if ($buttonFilter) {
        $buttonFilter.forEach((btnFilter) => {
            btnFilter.addEventListener("click", () => {
                gsap.set($contentFilter, { display: "block" });
                gsap.set($popupContent, { height: "90%" });
                tlPopup.play();
            });
        });

        let sliderRange = document.getElementById("slider-round");

        // eslint-disable-next-line no-undef
        noUiSlider.create(sliderRange, {
            start: [5, 6000],
            connect: true,
            range: {
                min: 5,
                max: 6000,
            },
            format: {
                to: (value) => Math.round(value),
                from: (value) => Number(value),
            },
        });

        const minValue = document.getElementById("min-value");
        const maxValue = document.getElementById("max-value");

        sliderRange.noUiSlider.on("update", (values) => {
            minValue.textContent = `€${values[0]}`;
            maxValue.textContent = `€${values[1]}`;
        });
    }

    // Popup Status
    if ($buttonStatus) {
        $buttonStatus.forEach((btnStatus) => {
            btnStatus.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentStatus, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Popup Numero de serie
    if ($buttonSerie) {
        $buttonSerie.forEach((btnSerie) => {
            btnSerie.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentSerie, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Popup Capacity
    if ($buttonCapacity) {
        $buttonCapacity.forEach((btnCapacity) => {
            btnCapacity.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentCapacity, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Popup Capacity
    if ($buttonMemory) {
        $buttonMemory.forEach((btnMemory) => {
            btnMemory.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentMemory, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Menu popup tabs
    const $menuTab = document.querySelector(".content-description-popup");
    if ($menuTab) {
        new Swiper(".tabmenu-swiper", {
            slidesPerView: "auto",
            spaceBetween: 20,
            grabCursor: true,
            freeMode: true,
            breakpoints: {
                // ≥ 768px
                768: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
            },
        });
    }

    const buttonsTabs = document.querySelectorAll(".tab-button");
    const panelsTabs = document.querySelectorAll(".tab-panel");

    buttonsTabs.forEach((btn, i) => {
        btn.addEventListener("click", () => {
            // Quitar la clase activa de todos los botones y paneles
            buttonsTabs.forEach((b) => b.classList.remove("active"));
            panelsTabs.forEach((p) => p.classList.remove("active"));

            // Activar el botón y panel correspondiente
            btn.classList.add("active");
            panelsTabs[i].classList.add("active");
        });
    });

    // Popup description
    if ($buttonDescription) {
        $buttonDescription.forEach((btnDescription, index) => {
            btnDescription.addEventListener("click", () => {
                buttonsTabs.forEach((b) => b.classList.remove("active"));
                panelsTabs.forEach((p) => p.classList.remove("active"));
                buttonsTabs[index].classList.add("active");
                panelsTabs[index].classList.add("active");
                gsap.set($popupContent, { height: isDesktop ? "50%" : "90%" });
                gsap.set($contentDescription, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Popup editar password
    if ($editarPassword) {
        $editarPassword.forEach((btnEditPassword) => {
            btnEditPassword.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentPassword, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Popup cancelar pedido
    if ($cancelarPedido) {
        $cancelarPedido.forEach((btnCancelarPedido) => {
            btnCancelarPedido.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentCancelarPedido, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Popup Eliminar Direccion
    if ($eliminarDireccion) {
        $eliminarDireccion.forEach((btnEliminarDireccion) => {
            btnEliminarDireccion.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentElinimarPedido, { display: "block" });
                tlPopup.play();
            });
        });
    }

    // Popup Generico
    if ($generico) {
        $generico.forEach((btnGnerico) => {
            btnGnerico.addEventListener("click", () => {
                gsap.set($popupContent, { height: "auto" });
                gsap.set($contentGenerico, { display: "block" });
                tlPopup.play();
            });
        });
    }

    const cerrarPopup = () => {
        gsap.set($contentFilter, { display: "none", delay: 0.4 });
        gsap.set($contentStatus, { display: "none", delay: 0.4 });
        gsap.set($contentCapacity, { display: "none", delay: 0.4 });
        gsap.set($contentMemory, { display: "none", delay: 0.4 });
        gsap.set($contentSerie, { display: "none", delay: 0.4 });
        gsap.set($contentDescription, { display: "none", delay: 0.4 });
        gsap.set($contentPassword, { display: "none", delay: 0.4 });
        gsap.set($contentCancelarPedido, { display: "none", delay: 0.4 });
        gsap.set($contentElinimarPedido, { display: "none", delay: 0.4 });
        gsap.set($contentGenerico, { display: "none", delay: 0.4 });
        tlPopup.reverse();
    };

    if ($closePopup) {
        $closePopup.addEventListener("click", () => {
            cerrarPopup();
        });
    }

    // Efecto formulario
    if ($inputGroup) {
        $inputGroup.forEach((group) => {
            const input = group.querySelector("input");
            const clearBtn = group.querySelector(".clear-btn");

            if (clearBtn) {
                const toggleClear = () => {
                    clearBtn.style.display = input.value ? "block" : "none";
                };

                clearBtn.addEventListener("click", () => {
                    input.value = "";
                    input.focus();
                    toggleClear();
                });

                input.addEventListener("input", toggleClear);
                toggleClear();
            }
        });
    }

    // mostrar contraseña

    if ($inputPassword) {
        $inputPassword.forEach((group) => {
            const input = group.querySelector("input");
            const toggle = group.querySelector(".toggle-password");

            toggle.addEventListener("click", () => {
                const isPassword = input.type === "password";
                input.type = isPassword ? "text" : "password";
                toggle.innerHTML = isPassword
                    ? "<img src='img/ico-ojo-cerrado.svg' alt='ocultar contraseña' class='ico-ojo'>"
                    : "<img src='img/ico-ojo.svg' alt='ver contraseña' class='ico-ojo'>"; // Cambia el icono
            });
        });

        if ($guardarPassword) {
            $guardarPassword.addEventListener("click", () => {
                cerrarPopup();
            });
        }
    }

    if ($atrasPopup) {
        $atrasPopup.forEach((btnAtras) => {
            btnAtras.addEventListener("click", () => {
                cerrarPopup();
            });
        });
    }

    // efecto sobra filtrado resultado
    if (sticky) {
        if (!isDesktop) return;

        //menu sticky
        window.addEventListener("scroll", function () {
            sticky.classList.toggle("is-sticky", window.scrollY > 165);
        });
    }

    //Mostrar buscador
    $btnSearch.addEventListener("click", () => {
        gsap.to($contentSearch, {
            opacity: 1,
            duration: 0.8,
            ease: "expo.out",
            display: "flex",
        });
    });

    $btnCloseSearch.addEventListener("click", () => {
        gsap.to($contentSearch, {
            opacity: 0.0001,
            duration: 0.8,
            ease: "expo.out",
            display: "none",
        });
    });

    const onResize = () => {
        isDesktop = window.innerWidth >= 768;
    };

    window.addEventListener("resize", onResize);
});
